<template>
  <DsDocumentationSection
    tag="Documentación"
    title="Lo que necesitarás para tu proceso"
    title-id="hazte-duena-documentation-title"
    description="Reuné esta documentación para que tu proceso avance sin contratiempos."
    :image="documentationImage"
    image-alt="Mujer en la entrada de su nueva propiedad"
    :items="documentationItems"
  />
</template>

<script setup lang="ts">
import documentationImage from '../../../assets/hazte-duena/doc_imagen.jpg'
import identificationIcon from '../../../assets/hazte-duena/ic_doc_ine.svg'
import incomeIcon from '../../../assets/hazte-duena/ic_doc_ingresos.svg'
import legalIcon from '../../../assets/hazte-duena/ic_doc_legal.svg'
import warningIcon from '../../../assets/hazte-duena/ic_doc_aviso.svg'
import DsDocumentationSection from '../components/DsDocumentationSection.vue'

const documentationItems = [
  {
    id: 'identification',
    iconSrc: identificationIcon,
    iconWidth: 32,
    iconHeight: 26,
    text: 'Identificación Oficial (INE)'
  },
  {
    id: 'income',
    iconSrc: incomeIcon,
    text: 'Comprobantes de ingresos (recibos, facturas, estados de cuenta recientes, declaraciones fiscales)'
  },
  {
    id: 'legal',
    iconSrc: legalIcon,
    text: 'Información legal y de ubicación del inmueble'
  },
  {
    id: 'not-accepted',
    iconSrc: warningIcon,
    text: 'RECUERDA QUE NO ACEPTAMOS: Inmuebles con problemas legales o ingresos inconsistentes.'
  }
]
</script>
